module.exports = __webpack_public_path__ + "img/icShop blue.b19526cd.svg";